<template>
  <div class="footer">
    <div class="container">
      <h3 class="company">
        {{this.EventBus.getSystemText("footer_1")}} 
      </h3>

      <p class="footerInfo">
        {{this.EventBus.getSystemText("footer_2")}} <br/>
        {{this.EventBus.getSystemText("footer_3")}} <br/>
        {{this.EventBus.getSystemText("footer_4")}} <br/>
        Copyright ⓒ NdotLight. All Rights Reserved.
      </p>

      <div class="footerSns" style="margin-top:30px">
        <a href="https://www.facebook.com/ndotcad/" target="_blank">
          <img src="/static/sns/facebook.png" alt="">
        </a>
        <a href="https://www.instagram.com/ndotcad/" target="_blank">
          <img src="/static/sns/instagram.png" alt="">
        </a>
        <a href="https://www.youtube.com/c/NdotCAD/" target="_blank">
          <img src="/static/sns/youtube.png" alt="">
        </a>

        <span v-if="this.language === 'Korean'" class="locale ml-2" style="min-width:65px; padding:0;" @click="changeEnglish()">
          <span class="ndotlight">EN</span>
        </span>
        <span v-if="this.language === 'English'" class="locale ml-2" style="min-width:65px; padding:0;" @click="changeKorean()">
          <span class="ndotlight">KO</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      language: this.EventBus.language
    };
  },
  methods: {
    changeEnglish() {
      this.EventBus.changeEnglish();
      this.language = this.EventBus.language;
    },
    changeKorean() {
      this.EventBus.changeKorean();
      this.language = this.EventBus.language;
    }
  }
};
</script>
<style scoped>
.footer {
  width: 100%;
  border-top: 1px solid #dadce0;
  margin: 0 auto;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footerSns img {
  margin-right: 20px;
  color: #c2c8cc;
  cursor: pointer;
  transition: all 0.2s linear;
  width: 28px;
}

.locale {
  text-decoration: none;
}

.ndotlight {
  background: #eee;
  padding: 10px 20px 12px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 600;
  vertical-align: 6px;
  color: #3f474d;
  transition: all 0.2s linear;
  cursor: pointer;
}

.ndotlight i {
  color: #3f474d;
  padding: 3px;
}

.ndotlight:hover {
  background-color: #1ecad3;
  color: #fff;
  text-decoration: none;
}

.ndotlight:hover i {
  color: #fff;
}

.company {
  color: #3f474d;
  font-size: 18px;
  letter-spacing: -0.36px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 22px;
}

.footerInfo {
  font-size: 14px;
  letter-spacing: -0.28px;
  line-height: 22px;
  color: #828c94;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue